<canvas #techCanvas class="tech-canvas" aria-hidden="true"></canvas>
